module.exports = __webpack_public_path__ + "static/media/Mol.0fa79ea6.svg";